import React from "react"
import styled from "styled-components"
import { LeftSection } from "Styles"
import { theme } from "Theme"

const Grid = styled.div`
  padding: 2rem 0 0;
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const OfficesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
`

const OfficeLocation = styled.div`
  display: flex;
  font-weight: bold;
  font-size: ${theme.fontSize.small};
  text-align: left;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 6px 0;
  img {
    height: 16px;
    width: auto;
    margin: 0 6px 0 0;
  }
`

const OfficeType = styled.p`
  color: inherit;
  font-weight: bold;
  font-size: ${theme.fontSize.smallish};
  text-align: left;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 0;
`

const OfficeAddress = styled.p`
  color: inherit;
  font-weight: normal;
  font-size: ${theme.fontSize.smallish};
  text-align: left;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 0;
`

const Offices = ({ data }) => (
  <LeftSection.Content>
    <LeftSection.Title>Our Offices</LeftSection.Title>
    <Grid>
      <OfficesGrid>
        {data.map((office, i) => (
          <div key={i}>
            <OfficeLocation>
              <img
                src={office.node.flag}
                alt={`${office.node.location} Flag`}
                title={`${office.node.location} Flag`}
                width="16"
              />
              {office.node.location}
            </OfficeLocation>
            <OfficeType>{office.node.type}</OfficeType>
            <OfficeAddress>{office.node.address}</OfficeAddress>
            <br />
          </div>
        ))}
      </OfficesGrid>
    </Grid>
  </LeftSection.Content>
)

export default Offices
